export default "__VITE_ASSET__DWwjMt2k__"